import { render } from "./DevLanding.vue?vue&type=template&id=3f3bfb3d"
import script from "./DevLanding.vue?vue&type=script&lang=js"
export * from "./DevLanding.vue?vue&type=script&lang=js"

import "./DevLanding.vue?vue&type=style&index=0&id=3f3bfb3d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__